var map = {
	"./allBestCards.svg": 9103,
	"./allBlackCards.svg": 1938,
	"./allNotTrumps.svg": 9221,
	"./allQueens.svg": 7192,
	"./allRedCards.svg": 2123,
	"./allTrumps.svg": 7229,
	"./barelyWonBig.svg": 4647,
	"./barelyWonSmall.svg": 1873,
	"./biggestTake.svg": 5094,
	"./dailyGames.svg": 666,
	"./dailyZoles.svg": 3092,
	"./destroyedLeader.svg": 4549,
	"./dominatedLeader.svg": 2241,
	"./dominatedZole.svg": 3579,
	"./frequentDaysPlayed.svg": 2084,
	"./goldenCard.svg": 5979,
	"./hardBigWin.svg": 5822,
	"./hardBigWin2.svg": 561,
	"./hardSmallZoleWin.svg": 1646,
	"./hardSmallZoleWin2.svg": 2901,
	"./hardZoleWin.svg": 7265,
	"./hardZoleWin2.svg": 8468,
	"./level0small.svg": 1072,
	"./level1.svg": 4578,
	"./level1small.svg": 9493,
	"./level2.svg": 6015,
	"./level2small.svg": 3593,
	"./level3.svg": 1471,
	"./level3small.svg": 6512,
	"./level4.svg": 1222,
	"./level4small.svg": 2248,
	"./level5.svg": 5718,
	"./level5small.svg": 4673,
	"./level6.svg": 1430,
	"./level6small.svg": 3286,
	"./level7.svg": 8218,
	"./level7small.svg": 6353,
	"./level8.svg": 8219,
	"./level8small.svg": 8735,
	"./monthlyGames.svg": 6916,
	"./smallestTake.svg": 6245,
	"./totalGames.svg": 3876,
	"./totalPoints.svg": 6745,
	"./totalWins.svg": 9137,
	"./totalWonSmallZoles.svg": 5497,
	"./totalWonTables.svg": 2187,
	"./totalWonZoles.svg": 9514,
	"./tourneyTop10.svg": 6477,
	"./tourneyTop3.svg": 8013,
	"./tourneys.svg": 6475,
	"./winsInARow.svg": 4212,
	"./wonSmallZoleOnLastHand.svg": 1808
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2274;